import axiosInstance from "../lib/axios";

export interface DashboardSummary {
  totalPenjualan: number;
  quotationAccepted: number;
  invoicePaid: number;
  deliveryOrderDone: number;
}

export interface RevenueTrendItem {
  period: string;
  total: number;
}

export interface StatusBreakdownItem {
  id: number;
  code: string;
  name: string;
  color: string;
  count: number;
}

export interface StatusBreakdownResult {
  docType: string;
  breakdown: StatusBreakdownItem[];
  total: number;
}

export interface SalesRevenueRow {
  salesId: number;
  salesName: string;
  monthly: number[];
  totalRevenue: number;
}

export interface SalesRevenueResponse {
  periods: {
    key: string;
    label: string;
  }[];

  rows: SalesRevenueRow[];
}

export const getDashboardSummary = async (startDate: string, endDate: string) => {
  const { data } = await axiosInstance.post("/Dashboard/Summary", { startDate, endDate });
  return data.data as DashboardSummary;
};

export const getRevenueTrend = async (
  startDate: string,
  endDate: string
) => {
  const { data } = await axiosInstance.post("/Dashboard/RevenueTrend", {
    startDate,
    endDate,
  });

  return data.data as RevenueTrendItem[];
};

export const getStatusBreakdown = async (
  docType: "quotation" | "invoice" | "delivery_order",
  startDate: string,
  endDate: string
) => {
  const { data } = await axiosInstance.post("/Dashboard/StatusBreakdown", {
    docType,
    startDate,
    endDate,
  });
  return data.data as StatusBreakdownResult;
};

export const getSalesRevenue = async (
  startDate: string,
  endDate: string
): Promise<SalesRevenueResponse> => {
  const response = await axiosInstance.post("/Dashboard/SalesRevenue", {
    startDate,
    endDate,
  });

  return response.data.data;
};
